// extracted by mini-css-extract-plugin
export default {"section":"Woman_section__ha01x","container":"Woman_container__Kd+Zq","container__photo":"Woman_container__photo__vqUtz","photo":"Woman_photo__ZcdZp"};